import { render } from "./InfoAfter.vue?vue&type=template&id=5dae22c0"
import script from "./InfoAfter.vue?vue&type=script&lang=js"
export * from "./InfoAfter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__